export default "__VITE_ASSET__a2Wuu0YJ__"